module.exports = __webpack_public_path__ + "static/media/file-zip.1d1a4e42.svg";